import React from 'react';
import { CONTENT_TYPES } from '../../../core/constants';
import { ALMANAC } from '../../Pages';

export default {
  path: ALMANAC.pageURL,
  async action() {
    const { default: AlmanacEditor } = await import('./AlmanacEditor');
    return (
      <AlmanacEditor
        contentType={CONTENT_TYPES.ALMANACH}
        key={'almanach'}
        page={ALMANAC}
      />
    );
  },
};
